/**
 * /admin/fic-reports/$id — FIC report detail (route shell).
 * Screen impl in `./fic-reports.$id-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/fic-reports/$id')({
  component: lazyRouteComponent(
    () => import('./fic-reports.$id-screen'),
    'AdminFicReportDetail',
  ),
});
